import { memo } from "react";
import Unit from "../../common/types/unit";

interface Props {
    value?: number,
    isLoading?: boolean,
    unit?: Unit,
    suffix?: string,
    defaultValue?: string,
    loadingValue?: string,
    isFloatNumber?: boolean,
}

const Cell = ({
    value = undefined,
    isLoading = false,
    loadingValue = '?',
    defaultValue = '-',
    unit = undefined,
    suffix = undefined,
    isFloatNumber = false,
}: Props) => {
    if (isLoading) {
        return loadingValue;
    }

    const formattedUnit = unit ? ` ${unit}` : '';
    const formattedValue = value && isFloatNumber ? value.toFixed(2): value;

    return (
        <>
            {value ? `${formattedValue}${formattedUnit}` : defaultValue}
            {(value && suffix) ? <sup>{suffix}</sup> : ''}
        </>
    );
};

export default memo(Cell);
